module.exports = __webpack_public_path__ + "static/media/1023346.9109b65c.png";